import { Component } from 'react'
import { reportError } from '@/observability'
import { AppErrorBoundaryFallbackView } from './AppErrorBoundaryFallbackView'

export class AppErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    if (import.meta.env.DEV && typeof console !== 'undefined' && console.error) {
      console.error('[AppErrorBoundary]', error, info?.componentStack)
    }
    reportError(error, {
      source: 'boundary',
      componentStack: info?.componentStack,
    })
  }

  handleReload = () => {
    this.setState({ error: null })
    window.location.reload()
  }

  render() {
    const { error } = this.state
    const { children } = this.props

    if (error) {
      return <AppErrorBoundaryFallbackView error={error} onReload={this.handleReload} />
    }

    return children
  }
}
